import { combineReducers } from "redux";
import * as actions from "../../actions/types";

const isProcessing = (state = false, action) => {
    switch (action.type) {
        case actions.GET_STRIPE_URL:
        case actions.STRIPE_CREATE_PAYMENT_INTENT:
            return true;
        case actions.GET_STRIPE_URL_SUCCESS:
        case actions.GET_STRIPE_URL_ERROR:
        case actions.STRIPE_CREATE_PAYMENT_INTENT_SUCCESS:
        case actions.STRIPE_CREATE_PAYMENT_INTENT_ERROR:
            return false;
        default:
            return state;
    }
};

// @todo handle multiple client secrets by context
const clientSecret = (state = null, action) => {
    switch (action.type) {
        case actions.CHECKOUT_INIT:
        case actions.CHECKOUT_ABANDON:
            return null;
        case actions.STRIPE_CREATE_PAYMENT_INTENT_SUCCESS:
            return action.data.client_secret || null;
        default:
            return state;
    }
};

// @todo handle multiple return urls by context
const returnUrl = (state = null, action) => {
    switch (action.type) {
        case actions.CHECKOUT_INIT:
        case actions.CHECKOUT_ABANDON:
            return null;
        case actions.STRIPE_CREATE_PAYMENT_INTENT_SUCCESS:
            return action.data.return_url || null;
        default:
            return state;
    }
};

// @todo handle multiple transaction ids by context
const transactionId = (state = null, action) => {
    switch (action.type) {
        case actions.CHECKOUT_INIT:
        case actions.CHECKOUT_ABANDON:
            return null;
        case actions.STRIPE_CREATE_PAYMENT_INTENT_SUCCESS:
            return action.data.transaction_id || null;
        default:
            return state;
    }
};

const url = (state = null, action) => {
    switch (action.type) {
        case actions.GET_STRIPE_URL:
        case actions.GET_STRIPE_URL_ERROR:
            return null;
        case actions.GET_STRIPE_URL_SUCCESS:
            return action.data.url;
        default:
            return state;
    }
};

export default combineReducers({
    clientSecret,
    isProcessing,
    returnUrl,
    transactionId,
    url,
});